import type { NavId } from "../components/AppShell";

function navFromSegment(segment: string): NavId | null {
  if (
    segment === "dashboard" ||
    segment === "subscriptions" ||
    segment === "settings" ||
    segment === "account"
  )
    return segment;
  return null;
}

/** Read SPA nav from `location.hash` (e.g. `#/settings`). */
export function getNavFromLocationHash(): NavId | null {
  const raw = window.location.hash.replace(/^#/, "").trim();
  if (!raw) return null;
  const segment = raw.split("/").find(Boolean);
  return segment ? navFromSegment(segment) : null;
}

/** Keep the hash aligned with the active tab so refresh restores the same page. */
export function syncLocationHashToNav(id: NavId): void {
  const next = `#/${id}`;
  if (window.location.hash !== next) {
    window.location.hash = next;
  }
}
